import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { remove } from 'features/session/store/actions'
import reducers from './reducers'

import * as api from 'gipsy-api'

const init = () => {
  let store
  if (process.env.REACT_APP_BACKEND_URL === 'https://api.gipsybot.com') {
    store = createStore(reducers, applyMiddleware(thunk.withExtraArgument({ api })))
  } else {
    store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk.withExtraArgument({ api }))))
  }
  api.listeners.onRefreshTokenFailed = () => {
    store.dispatch(remove())
  }
  return store
}

export default init()



// WEBPACK FOOTER //
// ./src/store.js